<template>
  <div class="participant">
    <Progression
      v-if="
        Object.entries(participant).length === 0 &&
          participant.constructor === Object
      "
    ></Progression>
    <div v-else class="participant-info">
      <div class="participant-header flex-table" style="word-wrap: break-word">
        <div>{{ participant.firstname + " " + participant.lastname }}</div>
        <div>
          {{
            $t(
              "user.roles." +
                (participant.role ? participant.role + ".title" : "undefined")
            )
          }}
        </div>
        <div>{{ participant.email }}</div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="participant.reason"
          prepend-icon="short_text"
          :readonly="!editable"
          :rules="$rules('app.text.small')"
          :label="$t('scheduler.participant.fields.reason')"
          @change="update"
        ></v-text-field>
        <v-text-field
          v-model="participant.notice"
          prepend-icon="short_text"
          :readonly="!editable"
          :rules="$rules('app.text.small')"
          :label="$t('scheduler.participant.fields.notice')"
          @change="update"
        ></v-text-field>
      </v-form>
      <v-btn
        v-if="editable"
        class="white--text"
        color="mdred lighten-1"
        @click="removeParticipant"
      >
        Remove
      </v-btn>
    </div>
  </div>
</template>

<script>
import Progression from "@/components/Progression";
import { mapState } from "vuex";

export default {
  components: {
    Progression
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean
    }
  },
  data: () => ({
    valid: true,
    participant: {}
  }),
  computed: {
    ...mapState("toolbox/advanced-forms", ["data", "validating"])
  },
  watch: {
    data: function() {
      this.refreshParticipant();
    },
    validating: function() {
      if (this.validating) {
        this.$store.dispatch(
          "toolbox/advanced-forms/submitValidation",
          this.$refs.form.validate()
        );
      }
    }
  },
  mounted: function() {
    this.$nextTick(async function() {
      this.refreshParticipant();
    });
  },
  methods: {
    removeParticipant() {
      this.$store.dispatch("toolbox/advanced-forms/removeItem", this.id);
    },
    update() {
      this.$store.dispatch(
        "toolbox/advanced-forms/updateItem",
        this.participant
      );
    },
    refreshParticipant() {
      var id = this.id;
      const item = this.data.find(element => {
        return element.id === id;
      });
      this.$set(this.participant, "id", item.id);
      this.$set(this.participant, "email", item.email);
      this.$set(this.participant, "firstname", item.firstname);
      this.$set(this.participant, "lastname", item.lastname);
      this.$set(this.participant, "role", item.role);
      this.$set(this.participant, "reason", item.reason);
      this.$set(this.participant, "notice", item.notice);
    }
  }
};
</script>

<style lang="scss" scoped>
.participant {
  border-bottom: 1px black solid;
  padding: 10px;
}
.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 33%);
  padding: 10px;
}
</style>
